import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import './TopProgressBar.css';

// Cấu hình NProgress
nprogress.configure({
  showSpinner: false, // Ẩn spinner vòng tròn mặc định nếu muốn
  speed: 200, // Tốc độ animation chạy
  minimum: 0.3 // Phần trăm khởi đầu
});

const TopProgressBar = () => {
  const location = useLocation();
  const { isSwitching } = useLanguage();
  const isInitialMount = useRef(true);
  const wasSwitching = useRef(false);

  // Bắt đầu chạy nprogress ngay lập tức khi bắt đầu điều hướng (áp dụng cho cả Link và useNavigate)
  useEffect(() => {
    const originalPushState = window.history.pushState;
    window.history.pushState = function (...args) {
      nprogress.start();
      return originalPushState.apply(this, args);
    };

    const handlePopState = () => {
      nprogress.start();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.history.pushState = originalPushState;
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isSwitching) {
      nprogress.start();
      wasSwitching.current = true;
      isInitialMount.current = false;
      return;
    }

    // Nếu vừa đổi ngôn ngữ xong
    if (wasSwitching.current) {
      wasSwitching.current = false;
      nprogress.done();
      return;
    }

    // Bỏ qua lần render đầu tiên khi F5 trang
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // Khi route (pathname) thay đổi thành công, hoàn thành thanh tiến trình ngay lập tức
    nprogress.done();
  }, [location.pathname, isSwitching]); // Lắng nghe khi pathname hoặc ngôn ngữ thay đổi

  return null;
};

export default TopProgressBar;
